import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useState } from 'react';
import useInvoke from '../../../../../../state/hooks/use-invoke';
import { getInvokeFailureReason } from '../../../../../../state/hooks/use-invoke/utils';
import useResolve from '../../../../../../state/hooks/use-resolve';
import createInvokeRequest from '../../../../../../utils/actions/create-invoke-request';
import Action from '../index';
import { useFlexibleUiAnalyticsContext } from '../../../../../../state/flexible-ui-context';
const ServerAction = ({
  action,
  onClick,
  onError: onErrorCallback,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const analytics = useFlexibleUiAnalyticsContext();
  const invoke = useInvoke();
  const reload = useResolve();
  const handleClick = useCallback(async () => {
    if (action) {
      var _action$action;
      const smartLinkActionType = (_action$action = action.action) === null || _action$action === void 0 ? void 0 : _action$action.actionType;
      try {
        setIsLoading(true);
        analytics === null || analytics === void 0 ? void 0 : analytics.ui.smartLinkServerActionClickedEvent({
          smartLinkActionType
        });
        analytics === null || analytics === void 0 ? void 0 : analytics.track.smartLinkQuickActionStarted({
          smartLinkActionType
        });
        const request = createInvokeRequest(action);
        await invoke(request);
        analytics === null || analytics === void 0 ? void 0 : analytics.track.smartLinkQuickActionSuccess({
          smartLinkActionType
        });
        if (action.reload && action.reload.url) {
          await reload(action.reload.url, true, undefined, action.reload.id);
        }
        setIsLoading(false);
        if (onClick) {
          onClick();
        }
      } catch (err) {
        setIsLoading(false);
        analytics === null || analytics === void 0 ? void 0 : analytics.track.smartLinkQuickActionFailed({
          smartLinkActionType,
          reason: getInvokeFailureReason(err)
        });
        onErrorCallback === null || onErrorCallback === void 0 ? void 0 : onErrorCallback();
      }
    }
  }, [action, analytics === null || analytics === void 0 ? void 0 : analytics.track, analytics === null || analytics === void 0 ? void 0 : analytics.ui, invoke, onClick, onErrorCallback, reload]);
  return /*#__PURE__*/React.createElement(Action, _extends({}, props, {
    isLoading: isLoading,
    onClick: handleClick
  }));
};
export default ServerAction;